import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import * as fromStore from 'app/main/auth/login/store';
import {Store} from '@ngrx/store';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from "@angular/material/snack-bar";
import { CdkUtils } from '@cdk/utils';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private store = inject<Store<fromStore.LoginState>>(Store);
    private snackBar = inject(MatSnackBar);


    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';



    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((err) => {
            if (err.status !== 401 && err.status !== 422 && err.status !== 504) {
                const error = (err.error.message || err.statusText || 'Erro desconhecido!').replace('Unknown Error', 'Erro Desconhecido!');
                /**
                 * Rev. 17/10/2024
                 * Issue: comissao-tecnica-sapiens/-/issues/2010
                 */
                let errorMessage = CdkUtils.cleanErrorMessage(error);
                this.snackBar.open(errorMessage, 'Fechar', {
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                    panelClass: ['danger-snackbar'],
                    duration: 30000
                });
            }
            return throwError(err);
        }));
    }
}
